import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import BackLink from "../components/BackLink";
import JourneyProgress from "../components/JourneyProgress";
import { ReactComponent as IconQuote } from "../assets/icon-quote.svg";
import { Link } from "react-router-dom";
import classes from "./QuoteSent.module.scss";

function QuoteSent() {
  return (
    <Container className={`phone-container ${classes.quoteSentContainer}`}>
      <BackLink desktop />
      <Row className="content">
        <Col xs={12}>
          <JourneyProgress mobile className={"mt-2"} />
          <div className={classes["quote-sent"]}>
            <IconQuote className={"mt-4"} />
            <h1 className={"mt-4 quote-sent"}>Quote Sent</h1>
            <p>
              Thank you, your quote has been
              <br />
              sent to your inbox.
            </p>
          </div>
        </Col>
      </Row>
      <Row className={`${classes.bottomPanel} border-top`}>
        <Col xs={6}>
          <Link to={"/"}>
            <Button
              variant={"outline-primary"}
              className={"btn-md w-100"}
              type={"submit"}
            >
              Return To Website
            </Button>
          </Link>
        </Col>
        <Col xs={6}>
          <Button
            className={"btn-md w-100"}
            type={"submit"}
            onClick={() => window.history.back()}
          >
            Return To Units
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default QuoteSent;
